import {
  TOPBAR_SWITCH_LOGOUT_DIALOG_VISIBILITY,
  SUBMIT_DIALOG_SHOW
} from "../lib/types";

export const showSubmitDialog = () => dispatch => {
  dispatch({
    type: SUBMIT_DIALOG_SHOW
  });
};

export const switchLogoutDialogVisibility = show => dispatch => {
  dispatch({
    type: TOPBAR_SWITCH_LOGOUT_DIALOG_VISIBILITY,
    payload: show
  });
};



// WEBPACK FOOTER //
// ./src/actions/topbar-actions.js